import type { ColDef } from 'ag-grid-enterprise'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import type { MarketSummary } from '@fortem-monorepo/web-sdk'

import type { DataGridContentBlock } from '@/components/content-blocks/blocks/data-grid/types'
import { createDefaultDataGridColumnDefs } from '@/components/content-blocks/blocks/data-grid/utils'

import { formatMarketSummaryMetric } from './market-summary-format'

const formatAbsoluteChange = numberFormatter({ minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const createMarketSummaryColumnDefs = (
  block: DataGridContentBlock<MarketSummary.ReportRow>,
): ColDef<MarketSummary.ReportRow>[] =>
  createDefaultDataGridColumnDefs(block).map((definition, index) => {
    const colDef = definition as ColDef<MarketSummary.ReportRow>
    if (!block.columns[index].roles?.includes('instrument_return')) return colDef
    const defaultFormatter = colDef.valueFormatter

    return {
      ...colDef,
      valueFormatter: (params) => {
        const formatted = formatMarketSummaryMetric(params.value, params.data)
        if (formatted !== undefined) return formatted
        if (params.data?.value_type === 'absolute') return formatAbsoluteChange(params)
        return typeof defaultFormatter === 'function' ? defaultFormatter(params) : params.value
      },
    }
  })
